import type { SVGProps } from "react";

export const ForwardDirectionArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 17.5V12.5C5 12.0417 5.16319 11.6493 5.48958 11.3229C5.81597 10.9965 6.20833 10.8333 6.66667 10.8333H13.3333V5.66667L12 7L10.8333 5.83333L14.1667 2.5L17.5 5.83333L16.3333 7L15 5.66667V10.8333C15 11.2917 14.8368 11.684 14.5104 12.0104C14.184 12.3368 13.7917 12.5 13.3333 12.5H6.66667V17.5H5Z"
      fill="#C5C6C9"
    />
  </svg>
);
